module.exports = __webpack_public_path__ + "img/file-plus-circle.8ccc1e56.svg";